import Style from "./css/style.module.css";
import { useState, useRef, useEffect } from 'react';
import RightScrollFix from "@/pcomponents/common/content/list/right_scroll_fix";
import SearchArea from "@/pages/comp/basic/student/list/area/search/search_area";
import StuSearchList from "./area/stu_list";
import ManageStudyArea from "./area/manage_study";

function StudyStuProgressArea(props: any) {
  let myProps = {
    ...props
  };
  const left_box_ref = useRef<any>(null);
  const StuSearchListRef = useRef<any>(null);
  const right_box_ref = useRef<any>(null);
  const ManageStudyAreaRef = useRef<any>(null);
  const [stu_list_opt, set_stu_list_opt] = useState<any>({});

  useEffect(() => {
    if (StuSearchListRef.current) {
      set_stu_list_opt(StuSearchListRef.current.getListOpt());
    }
  }, []);

  const go_search_progress = (inData: any) => {
    let opt_obj = {
      "s_stu_user_seq": [],
      "s_stu_info_arr": [],
      ...inData
    };

    if (ManageStudyAreaRef.current) {
      let s_stu_seq = "";
      if (opt_obj["s_stu_user_seq"] && opt_obj["s_stu_user_seq"].length > 0) {
        s_stu_seq = opt_obj["s_stu_user_seq"][0];
      }
      ManageStudyAreaRef.current.setInitData({
        stu_seq: s_stu_seq
      });
    }
  };

  const go_search_user_list = (inData: any) => {
    if (StuSearchListRef.current) {
      StuSearchListRef.current.list(inData);
    }
  };

  return (
    <div>
      {stu_list_opt.s_user_name_like != undefined &&
        <SearchArea
          listOpt={stu_list_opt}
          setListOpt={(inData: any) => {
            if (StuSearchListRef.current) {
              StuSearchListRef.current.setListOpt(inData);
              set_stu_list_opt(inData);
            }
          }}
          list={(inData: any) => {
            if (StuSearchListRef.current) {
              StuSearchListRef.current.list(inData);
              set_stu_list_opt({
                ...stu_list_opt,
                ...inData
              });
            }
          }}
        ></SearchArea>
      }
      <div className={Style.wrap}>
        <div className={Style.left_box} ref={left_box_ref}>
          <StuSearchList
            ref={StuSearchListRef}
            listOpt={stu_list_opt}
            list={(inData: any) => { go_search_progress(inData); }}
            is_show_search_area={false}
          ></StuSearchList>
        </div>
        <div className={Style.right_box} >
          <div ref={right_box_ref} style={{ paddingTop: "5px" }}>
            <ManageStudyArea
              ref={ManageStudyAreaRef}
              search_user_list={(inData: any) => { go_search_user_list(inData); }}
            ></ManageStudyArea>
          </div>
        </div>
        <RightScrollFix
          right_ref={right_box_ref}
          limit_scroll_top={300}
        ></RightScrollFix>
      </div>
    </div>
  );
}

export default StudyStuProgressArea;